module.exports = __webpack_public_path__ + "img/22.57807dc.jpg";